import {
 AlertDialog,
 AlertDialogAction,
 AlertDialogCancel,
 AlertDialogContent,
 AlertDialogDescription,
 AlertDialogFooter,
 AlertDialogHeader,
 AlertDialogTitle,
} from "@/components/ui/alert-dialog";

interface InactivityWarningDialogProps {
 open: boolean;
 remainingSeconds: number;
 onStayLoggedIn: () => void;
 onLogout: () => void;
}

/**
 * Format seconds into MM:SS display
 */
function formatTime(totalSeconds: number): string {
 const minutes = Math.floor(totalSeconds / 60);
 const seconds = totalSeconds % 60;
 return `${minutes}:${seconds.toString().padStart(2, '0')}`;
}

/**
 * Inactivity Warning Dialog
 * 
 * Displays a warning to the user before automatic logout due to inactivity.
 * Shows a countdown timer and provides options to stay logged in or logout immediately.
 * Cannot be dismissed by clicking outside or pressing Escape.
 */
export const InactivityWarningDialog = ({
 open,
 remainingSeconds,
 onStayLoggedIn,
 onLogout,
}: InactivityWarningDialogProps) => {
 return (
 <AlertDialog 
 open={open} 
 onOpenChange={() => {
 // Prevent closing via outside click or Escape
 // Only allow closing through explicit button actions
 }}
 >
 <AlertDialogContent
 onEscapeKeyDown={(e: any) => e.preventDefault()}
 {...{ onPointerDownOutside: (e: any) => e.preventDefault(), onInteractOutside: (e: any) => e.preventDefault() } as any}
 >
 <AlertDialogHeader>
 <AlertDialogTitle>Session Expiring Soon</AlertDialogTitle>
 <AlertDialogDescription className="space-y-3">
 <p>
 You will be automatically logged out due to inactivity.
 </p>
 <p className="text-2xl font-bold text-center py-4 text-foreground">
 {formatTime(remainingSeconds)}
 </p>
 <p className="text-center">
 Click "Stay Logged In" to continue your session.
 </p>
 </AlertDialogDescription>
 </AlertDialogHeader>
 <AlertDialogFooter>
 <AlertDialogCancel onClick={onLogout}>
 Logout Now
 </AlertDialogCancel>
 <AlertDialogAction onClick={onStayLoggedIn}>
 Stay Logged In
 </AlertDialogAction>
 </AlertDialogFooter>
 </AlertDialogContent>
 </AlertDialog>
 );
};
